<ideal-item-results [productId]="id()" *renderInProductDetailsView="LayoutTargets.Actions; id: 'product-id'" />

<!-- <div product-id *renderInProductDetailsView="LayoutTargets.Title; id: 'product-id'">WWWWWWWWWWWWWWWWWWWWWWWWWWWWW</div> -->
<!-- <ideal-image image [src]="thumbnailUrl()" *renderInProductDetailsView="LayoutTargets.Images; id: 'thumbnail'" />

<ideal-product-vendor-link vendor-link [productId]="id()" *renderInProductDetailsView="LayoutTargets.Title; id: 'vendor-link'" />
<ideal-product-id-label product-id [productId]="id()" *renderInProductDetailsView="LayoutTargets.Title; id: 'product-id'" />
<ideal-product-short-description
  description
  [productId]="id()"
  *renderInProductDetailsView="LayoutTargets.Title; id: 'short-description'"
/>

<ideal-product-badges badges [productId]="id()" *renderInProductDetailsView="LayoutTargets.Badges; id: 'badges'" />
<ideal-product-certs certs *renderInProductDetailsView="LayoutTargets.Badges; id: 'certifications'" />
@if (specSheetUrl()) {
  <ideal-product-download-spec-sheet-button
    download-spec
    [productId]="id()"
    *renderInProductDetailsView="LayoutTargets.Badges; id: 'download-spec-sheet'"
  />
} -->

<!-- <ideal-product-not-returnable not-returnable [productId]="id()" *renderInProductDetailsView="LayoutTargets.Stock; id: 'not-returnable'" /> -->

<!-- <ideal-product-vendor-pod [productId]="id()" *renderInProductDetailsView="LayoutTargets.Vendor; id: 'vendor-info-pod'" /> -->

<!-- old -->
<!-- old -->
<!-- old -->
<!--
<ideal-product-is-canadian canadian [productId]="id()" *renderInProductDetailsView="LayoutTargets.Title"></ideal-product-is-canadian>

@if (longDescription()) {
  <ideal-product-long-description
    long-description
    *renderInProductDetailsView="LayoutTargets.LongDescription"
    [productId]="id()"
  ></ideal-product-long-description>
}

<ideal-product-section-cross-references xrefs *renderInProductDetailsView [productId]="id()"></ideal-product-section-cross-references>
<ideal-product-section-specifications specifications *renderInProductDetailsView [productId]="id()"></ideal-product-section-specifications>
<ideal-product-section-links links *renderInProductDetailsView [productId]="id()"></ideal-product-section-links>

<ideal-product-alternates-section alternates *renderInProductDetailsView [productId]="id()"></ideal-product-alternates-section>
<ideal-product-section-complimentary complimentary *renderInProductDetailsView [productId]="id()"></ideal-product-section-complimentary> -->

<!-- <ideal-item-results *renderInProductDetailsView="LayoutTargets.Actions" [productId]="id()"></ideal-item-results> -->

<!--




<div pricing *renderInProductDetailsView="LayoutTargets.Actions">
  <ideal-product-price [itemId]="id()" class="no-call-for-price"></ideal-product-price>
  <ideal-product-fees [itemId]="id()"></ideal-product-fees>
</div>
<ideal-product-fees fees [itemId]="id()" *renderInProductDetailsView="LayoutTargets.Info"></ideal-product-fees>





 -->
